import { Component, Inject, LOCALE_ID, Renderer2 } from '@angular/core';
import { ConfigService } from '../@vex/config/config.service';
import { Settings } from 'luxon';
import { DOCUMENT } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { NavigationService } from '../@vex/services/navigation.service';
import { LayoutService } from '../@vex/services/layout.service';
import { ActivatedRoute, Router } from '@angular/router';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { SplashScreenService } from '../@vex/services/splash-screen.service';
import { VexConfigName } from '../@vex/config/config-name.model';
import { ColorSchemeName } from '../@vex/config/colorSchemeName';
import { MatIconRegistry, SafeResourceUrlWithIconOptions } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ColorVariable, colorVariables } from '../@vex/components/config-panel/color-variables';
import { InfoUsuarioLogin } from './models/login.model';

@Component({
  selector: 'vex-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  usuarioEnSesion: InfoUsuarioLogin;


  constructor(private configService: ConfigService,
              private renderer: Renderer2,
              private platform: Platform,
              @Inject(DOCUMENT) private document: Document,
              @Inject(LOCALE_ID) private localeId: string,
              private layoutService: LayoutService,
              private route: ActivatedRoute,
              private navigationService: NavigationService,
              private splashScreenService: SplashScreenService,
              private readonly matIconRegistry: MatIconRegistry,
              private readonly domSanitizer: DomSanitizer,
              private router: Router) {

    Settings.defaultLocale = this.localeId;

    if (this.platform.BLINK) {
      this.renderer.addClass(this.document.body, 'is-blink');
    }

    this.matIconRegistry.addSvgIconResolver(
      (
        name: string,
        namespace: string
      ): SafeResourceUrl | SafeResourceUrlWithIconOptions | null => {
        switch (namespace) {
          case 'mat':
            return this.domSanitizer.bypassSecurityTrustResourceUrl(
              `assets/img/icons/material-design-icons/two-tone/${name}.svg`
            );

          case 'logo':
            return this.domSanitizer.bypassSecurityTrustResourceUrl(
              `assets/img/icons/logos/${name}.svg`
            );

          case 'flag':
            return this.domSanitizer.bypassSecurityTrustResourceUrl(
              `assets/img/icons/flags/${name}.svg`
            );
        }
      }
    );


    this.route.queryParamMap.subscribe(queryParamMap => {
      if (queryParamMap.has('layout')) {
        this.configService.setConfig(queryParamMap.get('layout') as VexConfigName);
      }

      if (queryParamMap.has('style')) {
        this.configService.updateConfig({
          style: {
            colorScheme: queryParamMap.get('style') as ColorSchemeName
          }
        });
      }

      if (queryParamMap.has('primaryColor')) {
        const color: ColorVariable = colorVariables[queryParamMap.get('primaryColor')];

        if (color) {
          this.configService.updateConfig({
            style: {
              colors: {
                primary: color
              }
            }
          });
        }
      }

      if (queryParamMap.has('rtl')) {
        this.configService.updateConfig({
          direction: coerceBooleanProperty(queryParamMap.get('rtl')) ? 'rtl' : 'ltr'
        });
      }
    });

    /**
     * Add your own routes here
     */

    if(!localStorage.getItem('usuario')){
      this.router.navigateByUrl('/login');
      return;
    }

      this.usuarioEnSesion = JSON.parse(localStorage.getItem('usuario'));


    let menu = [];

/*     switch(this.usuarioEnSesion.catTipoAuditoriaId){
      case 1: //INTERNA
        menu = [
          {
            type: 'subheading',
            label: '',
            children: [
              {
                type: 'link',
                label: 'Inicio',
                route: '/',
                icon: 'mat:dashboard',
                routerLinkActiveOptions: { exact: true }
              },
            ]
          },
          {
            type: 'subheading',
            label: 'Catálogos',
            children: [
              {
                type: 'link',
                label: 'Dias feriados',
                route: '/dias-feriados',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },
            ]
          },
          {
            type: 'subheading',
            label: 'Auditorias',
            children: [
              {
                type: 'link',
                label: 'Internas',
                route: '/admin-aud-interna',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              }
            ]
          },
          {
            type: 'subheading',
            label: 'Reportes',
            children: [
              {
                type: 'link',
                label: 'Visualización TimeLine',
                route: '/timeline',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              }
            ]
          }

        ]
      break;

      case 2: //Líneas de Acción de Mejora
      menu = [
        {
          type: 'subheading',
          label: '',
          children: [
            {
              type: 'link',
              label: 'Inicio',
              route: '/',
              icon: 'mat:dashboard',
              routerLinkActiveOptions: { exact: true }
            },
          ]
        },
        {
          type: 'subheading',
          label: 'Catálogos',
          children: [
            {
              type: 'link',
              label: 'Dias feriados',
              route: '/dias-feriados',
              icon: 'mat:list',
              routerLinkActiveOptions: { exact: true }
            },
          ]
        },
        {
          type: 'subheading',
          label: 'Auditorias',
          children: [
            {
              type: 'dropdown',
              label: 'Mejora',
              icon: 'mat:list',
              children: [
                {
                  type: 'link',
                  label: 'Líneas de Acción de Mejora',
                  route: '/admin-aud-mejora-uno',
                  icon: 'mat:label_important',
                  routerLinkActiveOptions: { exact: true }
                }
              ]
            }
          ]
        },
        {
          type: 'subheading',
          label: 'Reportes',
          children: [
            {
              type: 'link',
              label: 'Visualización TimeLine',
              route: '/timeline',
              icon: 'mat:list',
              routerLinkActiveOptions: { exact: true }
            }
          ]
        }

      ]
      break;

      case 3: //MEJORA Visita y/o Intervención
      menu = [
        {
          type: 'subheading',
          label: '',
          children: [
            {
              type: 'link',
              label: 'Inicio',
              route: '/',
              icon: 'mat:dashboard',
              routerLinkActiveOptions: { exact: true }
            },
          ]
        },
        {
          type: 'subheading',
          label: 'Catálogos',
          children: [
            {
              type: 'link',
              label: 'Dias feriados',
              route: '/dias-feriados',
              icon: 'mat:list',
              routerLinkActiveOptions: { exact: true }
            },
          ]
        },
        {
          type: 'subheading',
          label: 'Auditorias',
          children: [
            {
              type: 'dropdown',
              label: 'Mejora',
              icon: 'mat:list',
              children: [
                {
                  type: 'link',
                  label: 'Visita y/o Intervención',
                  route: '/admin-aud-mejora-tres',
                  icon: 'mat:label_important',
                  routerLinkActiveOptions: { exact: true }
                }
              ]
            }
          ]
        },
        {
          type: 'subheading',
          label: 'Reportes',
          children: [
            {
              type: 'link',
              label: 'Visualización TimeLine',
              route: '/timeline',
              icon: 'mat:list',
              routerLinkActiveOptions: { exact: true }
            }
          ]
        }

      ]
      break;

      case 4: //SEGUIMIENTO
      menu = [
        {
          type: 'subheading',
          label: '',
          children: [
            {
              type: 'link',
              label: 'Inicio',
              route: '/',
              icon: 'mat:dashboard',
              routerLinkActiveOptions: { exact: true }
            },
          ]
        },
        {
          type: 'subheading',
          label: 'Catálogos',
          children: [
            {
              type: 'link',
              label: 'Dias feriados',
              route: '/dias-feriados',
              icon: 'mat:list',
              routerLinkActiveOptions: { exact: true }
            },
          ]
        },
        {
          type: 'subheading',
          label: 'Auditorias',
          children: [
            {
              type: 'link',
              label: 'Seguimiento',
              route: '/seguimiento',
              icon: 'mat:list',
              routerLinkActiveOptions: { exact: true }
            }
          ]
        },
        {
          type: 'subheading',
          label: 'Reportes',
          children: [
            {
              type: 'link',
              label: 'Visualización TimeLine',
              route: '/timeline',
              icon: 'mat:list',
              routerLinkActiveOptions: { exact: true }
            }
          ]
        }

      ]
      break;

      case 5: //TODAS LAS PANTALLAS
        menu = [
          {
            type: 'link',
            label: 'Visualización TimeLine',
            route: '/timeline',
            icon: 'mat:list',
            routerLinkActiveOptions: { exact: true }
          },
          {
            type: 'link',
            label: 'Visualización TimeLine Mejora',
            route: '/timeline-mejora',
            icon: 'mat:list',
            routerLinkActiveOptions: { exact: true }
          }

        ]
      break;

    } */
    this.navigationService.items = menu;
  }

  ngOnInit(): void {


  }
}
